import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const ProtectedRoute = ({ children, roles }) => {
  const { user, token } = useAuth();
  const location = useLocation();
  if (!token) return <Navigate to="/login" replace />;
  if (!user) return null; // still loading via AuthContext
  if (roles && !roles.includes(user.role)) return <Navigate to="/app" replace />;
  // Forced first-login password change. Skip the redirect when the user is
  // already on /change-password — otherwise we'd loop forever and render
  // nothing (blank page).
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  return children;
};

export default ProtectedRoute;
